import { useState } from "react";
import NavbarSuperAdmin from "../../../components/navbar/NavbarSuperAdmin";
function EmployeeDashbooard({ userName, logout }) {
  let [data,setdata]=useState([])


  return (
    <>
     <NavbarSuperAdmin EmployeeDashbooard />
     {/* <EmployeeLayout userName={userName} logout={logout}>
      <h1>Welcome to Employee Dashboard</h1>
      <h2>Only “My Trips” is visible in sidebar for now</h2>
    </EmployeeLayout> */}
    </>
  );
}

export default EmployeeDashbooard;

//Note-its not in use.use employee dashboard for admin dashboard.
//